import {prefetch} from "./prefetch";

/**
 * Sends ajax request to {url} and parses result into element
 * @param url
 * @return {Promise<HTMLHtmlElement>}
 */
export function fetchPage(url) {
    url = new URL(url);
    url.searchParams.set("ajax", "1");

    return prefetch(url.toString()).then(res => res.clone().text()).then((text) => {
        const el = document.createElement("html");
        el.innerHTML = text;

        return el;
    });

}
